'use strict';



const $ = require('jquery');
const $refresh = $('[data-refresh]');
const url = '/_data-feed';
const pollInterval = 3000;


const renderers = {
	renderLoansIfAny
};



const entities = $refresh
	.map(function() {

		const $item = $(this);

		return {
			$item,
			type: $item.data('refresh-type'),
			id: $item.data('refresh')
		};

	})
	.get()
	.filter(entity => renderers[entity.type]);



if(entities.length > 0) {
	pollData(pollInterval);
}



function getRequestUrl(entities) {

	const request = entities
		.map(entity => `${entity.type}:${entity.id}`)
		.join('&');

	return `${url}/${request}`;

}



function pollData(interval = 800, maxInterval = 20000, _defaultInterval = interval) {

	if(interval > maxInterval) {
		interval = maxInterval;
	}

	const url = getRequestUrl(entities);
	const start = new Date().getTime();

	return $.get(url)
		.done(render)
		.always(() => {

			const duration = new Date().getTime() - start;
			let nextInterval = _defaultInterval;

			if(duration > 1000) {
				nextInterval = duration > 1500 ?
					interval * 3 :
					interval * 1.25;
			}

			const nextPollData = pollData.bind(null, nextInterval, maxInterval, _defaultInterval);

			setTimeout(nextPollData, interval);

		});

}



function render(resources) {

	if(typeof resources !== 'object') {
		return;
	}

	const renderResources = (resource, entities) =>
		entities.forEach(renderers[resource]);

	Object.keys(resources)
		.forEach(resource =>
			renderResources(resource, resources[resource]));

}



function getEntityElement(id) {
	return $refresh.filter(`[data-refresh=${id}]`);
}



/**
 * Render Loans If Any
 *
 * This renderer will trigger a page reload if the number of loans of the
 * given type is greater than zero. Therefore it should only be used when
 * no loans are displayed (to refresh and display loans when any become a match).
 */
function renderLoansIfAny(render) {
	if(render) {
		document.location.reload();
	}
}



function renderBindings($element, data) {

	const $bindings = $element.find('[data-refresh-bind]');

	$bindings.each(function() {

		const $binding = $(this);
		const property = $binding.data('refresh-bind');
		const value = data[property];

		$binding.text(value);

	});

}